var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterBw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitter2",
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 100,
    cy: 100,
    r: 95,
    stroke: "#727273",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "twitter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M 138.698 13.0064C 133.54 15.2121 128.044 16.6742 122.314 17.3841C 128.209 13.9529 132.708 8.56104 134.823 2.06209C 129.327 5.25663 123.259 7.5131 116.792 8.77232C 111.574 3.35512 104.136 0 96.0222 0C 80.28 0 67.6065 12.457 67.6065 27.7283C 67.6065 29.9256 67.7972 32.0384 68.2653 34.0498C 44.626 32.9258 23.7086 21.8801 9.65683 5.0538C 7.20361 9.20333 5.76463 13.9529 5.76463 19.0659C 5.76463 28.6664 10.8358 37.1767 18.3948 42.1038C 13.8264 42.0193 9.34476 40.7262 5.54791 38.6895C 5.54791 38.774 5.54791 38.8839 5.54791 38.9937C 5.54791 52.4649 15.4041 63.6543 28.329 66.2319C 26.0145 66.8488 23.4919 67.1446 20.874 67.1446C 19.0536 67.1446 17.2159 67.0432 15.4908 66.6713C 19.175 77.6494 29.6293 85.7203 42.0601 85.9823C 32.3859 93.3602 20.1025 97.8055 6.80486 97.8055C 4.473 97.8055 2.2365 97.7041 0 97.4252C 12.5955 105.344 27.5228 109.865 43.6204 109.865C 95.9442 109.865 124.551 67.6094 124.551 30.982C 124.551 29.7566 124.507 28.5734 124.447 27.3987C 130.09 23.4943 134.832 18.6179 138.698 13.0064Z",
    transform: "translate(37 51)",
    fill: "#727273"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#727273"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterBw);
export default __webpack_public_path__ + "static/media/twitter-bw.6f6a81469bcfe97450d83a97d93b1ada.svg";
export { ForwardRef as ReactComponent };